<template>
  <div>
    <div v-if="list.length > 0">
      <IntervalIOListWeb :list="list" class="hidden-sm-and-down" />
      <IntervalIOListMob :list="list" class="hidden-md-and-up" />
    </div>
    <div v-else>
      <empty-list />
    </div>
  </div>
</template>

<script>
import EosToastType from "../../../model/EosToastType";
import DateUtils from "../../../utils/DateUtils";
import IntervalIOListWeb from "../../io/IntervalIO/IntervalIOListWeb.vue";
import IntervalIOListMob from "../../io/IntervalIO/IntervalIOListMob.vue";

export default {
  props: {
    perno: String,
    date: String,
  },
  
  mounted() {
    this.GetPersonIoInfo();
  },
  data() {
    return {
      list: [],
    };
  },
  watch : {
    date(){
      this.GetPersonIoInfo()
    }
  },
  methods: {
    GetPersonIoInfo() {
      const params = new URLSearchParams();
      params.append("beginDate", DateUtils.fixDateFormatTwoDigit(this.date));
      params.append("endDate", DateUtils.fixDateFormatTwoDigit(this.date));
      params.append("perno", this.perno);
      this.$store
        .dispatch("GetPersonIoInfo", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.list = result.data;
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
    },
  },
  components: { IntervalIOListWeb, IntervalIOListMob },
};
</script>

<style>
</style>